import React, { Component } from 'react'
import './Table.scss'
import ActionButton, { ActionButtonGroup } from '../ActionButton/ActionButton'

const ALLOW_CORRECTION_STYLING = process.env.ALLOW_CORRECTION_STYLING

export default class Table extends Component {
  static defaultProps = {
    innerRef: () => {}
  }
  onCellClick = (rowIndex, rowId) => {
    if (this.props.onCellClick) {
      this.props.onCellClick(rowIndex, rowId)
    }
  }
  getActionsFromMap = (type = 'default', row) => {
    const { actionMap = {} } = this.props
    return typeof actionMap[type] === 'function' ? actionMap[type](row) : actionMap[type]
  }
  highlightRowByIndex = index => {
    this.rowRefs[index].highlight()
  }
  checkForClick = e => {
    if (this.props.sortable && (e.keyCode === 13 || e.keyCode === 32)) {
      e.target.click()
    }
  }
  render() {
    const {
      actionCell = false,
      actionCellClassName = '',
      animated = true,
      className = '',
      firstCellInteractive: interactive,
      innerRef,
      onHeaderLabelClicked,
      rowCount = false,
      rows = [],
      selectedRowIndex,
      sortable,
      sortBy,
      sortByDirection = '',
      template = [],
      totalRows = null
    } = this.props
    const firstCellInteractive = interactive === false ? false : true
    return (
      <React.Fragment>
        <span role="status" className="row-count">
          <span className="row-count-text">
            {rowCount && rows.length > 0 ? `Results: ${totalRows || rows.length}` : ''}
          </span>
        </span>
        <table ref={ref => innerRef(ref)} className={'div-table ' + className}>
          {template && rows.length > 0 ? (
            <thead
              className={'div-table-heading ' + (animated ? 'animated fadeIn fast-animation' : '')}
            >
              <tr>
                {template.map((t, i) => (
                  <th
                    className={`div-table-head ${sortable ? 'sortable' : ''}`}
                    key={i}
                    onClick={() => (onHeaderLabelClicked ? onHeaderLabelClicked(t.id) : undefined)}
                    tabIndex={sortable ? 0 : undefined}
                    onKeyDown={this.checkForClick}
                    aria-sort={
                      sortable && sortBy === t.id
                        ? sortByDirection.toUpperCase() === 'DESC'
                          ? 'descending'
                          : 'ascending'
                        : undefined
                    }
                  >
                    <div className="flex-row">
                      <span className="header-label">{t.label}</span>
                      {sortable ? (
                        <SortIndicator
                          sortByDirection={
                            sortBy && sortBy === t.id ? sortByDirection.toUpperCase() : ''
                          }
                        />
                      ) : null}
                    </div>
                  </th>
                ))}
                {actionCell ? <th className="div-table-head">Actions</th> : null}
              </tr>
            </thead>
          ) : null}
          <tbody className="div-table-body">
            {rows.map((row, i) => {
              const actions = this.getActionsFromMap(row.TYPE, row)
              return (
                <Row
                  cells={row}
                  template={template}
                  selected={i === selectedRowIndex}
                  onCellClick={this.onCellClick}
                  alert={row.ALERT_YN}
                  // id={row.ID}
                  // index={i}
                  rowIndex={i + 1}
                  key={row.ID + i.toString()}
                  actionCellClassName={actionCellClassName}
                  firstCellInteractive={firstCellInteractive}
                  ref={ref => {
                    this.rowRefs = [...(this.rowRefs || []), ref]
                  }}
                  actionCell={
                    actionCell ? (actions ? actions : this.getActionsFromMap('default')) : null
                  }
                />
              )
            })}
          </tbody>
        </table>
      </React.Fragment>
    )
  }
}

class Row extends React.Component {
  state = {
    highlighted: false
  }
  highlight = () => {
    this.setState({ highlighted: true })
  }
  checkForClick = e => {
    var code = e.charCode || e.keyCode
    if (code === 32 || code === 13) {
      const isActionButton = Array.from(e.target.parentElement.parentElement.classList).includes(
        'action-button'
      )
      if (!isActionButton) {
        e.preventDefault()
        this.props.onCellClick(this.props.cells)
      }
    }
  }
  render() {
    const {
      label,
      template,
      cells,
      onCellClick,
      selected,
      actionCell = [],
      actionCellClassName,
      firstCellInteractive
    } = this.props
    return (
      <tr
        className={`div-table-row ${selected ? 'selected' : ''} ${
          this.state.highlighted ? 'highlighted' : ''
        }`}
        aria-label={label}
        onKeyPress={this.checkForClick}
      >
        {template.map((t, i) => {
          const isFirstInteractiveCell = firstCellInteractive && i === 0

          const cellContent = (
            <React.Fragment>
              {typeof t.render === 'function' ? (
                <span className="cell">{t.render(cells[t.id])}</span>
              ) : Array.isArray(cells[t.id]) ? (
                cells[t.id].map((cellData, j) => (
                  <span className="cell" key={j}>
                    {cellData}
                  </span>
                ))
              ) : (
                <span className={`cell ${cells[t.id] === 'Needs Correction' && ALLOW_CORRECTION_STYLING ? 'danger-text-bold' : ''}`}>{cells[t.id]}</span>
              )}
              {isFirstInteractiveCell && <span className="icon icon-caret-right" />}
            </React.Fragment>
          )

          return (
            <td
              className={`div-table-cell ${selected ? 'selected' : ''} ${
                firstCellInteractive ? 'interactive' : ''
              }`}
              onClick={() => {
                if (isFirstInteractiveCell) {
                  onCellClick(cells)
                }
              }}
              key={i}
            >
              {cells.ALERT && i === 0 && (
                <div className="badge row-alert" key={i}>
                  !
                </div>
              )}
              {isFirstInteractiveCell ? (
                <div role="button" tabIndex={0} className="interactive-cell-button">
                  {cellContent}
                </div>
              ) : (
                cellContent
              )}
            </td>
          )
        })}
        {actionCell ? (
          <td className={`div-table-cell no-padding ${selected ? 'selected' : ''} action-cell`}>
            <ActionButtonGroup
              buttonSize="extra-small"
              className={`${actionCellClassName} table-button`}
            >
              {cells.NO_ACTIONS !== true &&
                actionCell.map((button, i) => {
                  const isVisible = button.getIsVisible ? button.getIsVisible(cells) : true
                  const label = typeof button.label === 'function' ? button.label(cells) : button.label
                  const classes = typeof button.className === 'function' ? button.className(cells) : button.className
                  if (isVisible) {
                    return (
                      <ActionButton
                        hideLabel={true}
                        tooltip={true}
                        {...button}
                        label={label}
                        className = {classes}
                        onClick={() => {
                          button.onClick(cells)
                        }}
                        key={i}
                        flex
                      />
                    )
                  } else {
                    return null
                  }
                })}
            </ActionButtonGroup>
          </td>
        ) : null}
      </tr>
    )
  }
}

const SortIndicator = ({ sortByDirection }) => (
  <div className="sort-indicator-wrapper">
    <div
      className={`sort-indicator ${
        sortByDirection ? (sortByDirection === 'DESC' ? 'descending' : 'ascending') : ''
      }`}
    />
  </div>
)



// WEBPACK FOOTER //
// ./src/components/Table/Table.js